export enum PaymentMethodsEnum {
    Geen = 0,
    Overschrijving = 1,
    Domiciliering = 2
}